module.exports = __webpack_public_path__ + "../resources/img/pw_check.e4e0c4f8.svg";